(function() {
	'use strict';
	angular.module('app.setup')
		.controller('updateTargets', updateTargets);

	updateTargets.$inject = ['$scope', '$rootScope', '$state', '$timeout', '$filter', '$uibModal', 'leanFilterService', 'leanTableService',
		'tableRenderService','tableService', 'numberFormatService', 'updateTargetsService', 'percentageFormatService', 'currencyFormatService', 'storeService', 'navigationService'];

	function updateTargets($scope, $rootScope, $state, $timeout, $filter, $uibModal, leanFilterService, leanTableService,
							  tableRenderService, tableService, numberFormatService, updateTargetsService, percentageFormatService, currencyFormatService, storeService, navigationService) {
		var vm = this;
		$scope.filterService = leanFilterService;
		$scope.tableService = leanTableService;
		var adminConfig = storeService.getState().adminConfig;
		var reportSettingsName = 'update-targets';
		vm.initialData = {};
		var metricNoOfWeeks = {};
		var metricConfigByNdx = {};
		var defaultYear;
		var columns = [
			{
				'id': 'category',
				'display': 'Category',
				'width': 240,
				'renderer': tableRenderService.categoryRenderer,
				'sort': false
			},
			{
				'id': 'name',
				'display': 'Metric',
				'width': 240,
				'renderer': tableRenderService.metricRenderer,
				'sort': false
			},
			{
				'id': '',
				'display': '',
				'class': 'monthCellWithTarget headerCell',
				'renderer': tableRenderService.targetActualHeaderRenderer,
				'hideMenu': true,
				'disabledShowHide': true,
				'width': 150,
				'sort': false
			}
		];

		var defaultFilters  = [
			{
				'id': 'metric',
				'values': [$scope.filterService.leanDnaAllSelected],
				'isMandatory': true
			}, {
				'id': 'valueStreamWithPerf',
				'values': [0],
				'isMandatory': true
			}, {
				'id': 'fy',
				'values': [getFiscalYear()],
				'isMandatory': true
			}
		];

		vm.months = {
			'month0': {
				'display': 'Jan'
			},
			'month1': {
				'display': 'Feb'
			},
			'month2': {
				'display': 'Mar'
			},
			'month3': {
				'display': 'Apr'
			},
			'month4': {
				'display': 'May'
			},
			'month5': {
				'display': 'Jun'
			},
			'month6': {
				'display': 'Jul'
			},
			'month7': {
				'display': 'Aug'
			},
			'month8': {
				'display': 'Sep'
			},
			'month9': {
				'display': 'Oct'
			},
			'month10': {
				'display': 'Nov'
			},
			'month11': {
				'display': 'Dec'
			}
		};

		init();

		for (var monthId in vm.months) {
			if (vm.months.hasOwnProperty(monthId)) {
				var month = vm.months[monthId];
				month.id = monthId;
				month.index = 0;
				month.sort = false;
				month.hideMenu = true;
				month.disabledShowHide = true;
				if (month.class === undefined) {
					month.class = 'monthCell alignCenter veryLargeTitle';
				}
				if (month.renderer === undefined) {
					month.renderer = tableRenderService.targetActualRenderer;
				}
				month.width = 150;
				columns.push(month);
			}

		}

		var reportSettingsId = undefined;
		$scope.subView = $scope.subView || {};
		$scope.subView.selectedView = 'Monthly';
		var view = $state.current.name === 'app.lean-projects.update-targets' ? 'projects-updatetargets' : 'updatetargets';
		vm.reportName = 'Update Monthly Targets';
		vm.showExcel = false;
		vm.initialLoad = true;

		var pinnedColumns = [];
		var rendererParams = {
			initialData: vm.initialData,
			monthIndexLessThanFactoryStartMonth: vm.monthIndexLessThanFactoryStartMonth
		};

		var extraParams = [{}];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportName: 'UpdateTargetsNew',
			noPaging: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			rendererParams: rendererParams,
			reportUrl: '{0}/UpdateTargetsReport',
			extraParams:extraParams,
			setColumnDefaults: true,
			hideSearch: true,
			showSaveButton: true,
			defaultFilters: defaultFilters,
			waitForFilters: true,
			reportSettingsScope: 'customer',
			hasMandatoryFilters: true,
			saveGridData: saveGridData
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.searchPlaceholderText = 'Search tasks...';
		vm.copyMetricTargets = copyMetricTargets;
		vm.saveGridData = saveGridData;

		var setFirstView = _.once(navigationService.setFirstView);

		function getData(params, extraParams, isFilterChanged) {
			return tableService.getData(params, extraParams).then(function (response) {
				if (response[0] && response[0].data) {
					if (!reportSettingsId) {
						setFirstView({'viewType': view}, reportSettingsName);
					}
					setHeaders(response[0].fiscalYear, response[0].factoryDate);
					showLimitedMetricsMessage(response[0]);
					organizeData(response[0].data);
				}
				return response;
			});
		}

		function getMeta() {
			return meta;
		}

		$scope.tableService.setReportSettingsName(reportSettingsName);
		$scope.filterService.searchType = 'task';

		function init() {
			$scope.filterService.clearFilters();
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'singleSelect';
			siteFilter.removable = false;
			siteFilter.masterObjectList = updateTargetsService.getAllowedSites();
			siteFilter.objectList = _.clone(siteFilter.masterObjectList);
			leanFilterService.useFactoryFilter = true;
			if (siteFilter.objectList && siteFilter.objectList.length) {
				defaultFilters.push({
					'id': 'factory',
					'values': [siteFilter.objectList[0].id],
					'isMandatory': true
				});
			}

			$scope.filterService.defaultFilters = defaultFilters;
			$scope.filterService.setMasterRangeFilterList([]);
			$scope.filterService.setMasterStringFilterList([]);
			// Edit filter settings to prevent user from removing and change valuestream to single select
			var metricFilter = $scope.filterService.filterDefinitions.MonthlyTargetMetric;
			// XXX still removable by unselecting all items
			metricFilter.removable = false;
			var vsfilter = $scope.filterService.filterDefinitions.ValueStreamWithPerf;
			vsfilter.type = 'singleSelect';
			vsfilter.removable = false;
			var fiscalFilter = $scope.filterService.filterDefinitions.FiscalYearList;
			fiscalFilter.removable = false;

			// Add multi-select filters
			$scope.filterService.setMasterFilterList([
				metricFilter,
				$scope.filterService.filterDefinitions.MetricCategories,
				$scope.filterService.filterDefinitions.MetricTypes
			]);

			// Add single-select filters
			$scope.filterService.setMasterSingleSelectFilterList([
				siteFilter,
				vsfilter,
				fiscalFilter
			]);
		}

		function organizeData(data) {
			var resultSet = updateTargetsService.organizeData(data);
			vm.initialData = resultSet.initialData;
			metricNoOfWeeks = resultSet.metricNoOfWeeks;
			metricConfigByNdx = resultSet.metricConfigByNdx;
			rendererParams.initialData = vm.initialData;
			rendererParams.monthIndexLessThanFactoryStartMonth = vm.monthIndexLessThanFactoryStartMonth;
			vm.initialData['valueStreamWithPerf'] = $scope.filterService.getSelectedIds('valueStreamWithPerf')[0];
		}

		function getColumn(id, cols) {
			var column;
			if (typeof cols === 'undefined') {
				cols = columns;
			}
			column = _.find(cols, {
				'id': id
			});
			if (!column) {
				cols = pinnedColumns;
				column = _.find(cols, {
					'id': id
				});
			}
			return column;
		}

		function setHeaders(fiscalYear, factoryDate) {
			var startDate = new Date(fiscalYear.startDate);
			var startMonth = startDate.getUTCMonth();
			var year = $scope.filterService.getSelectedIds('fy')[0];
			// this shouldn't happen because the filter is not removable
			if (year === undefined) {
				year = new Date(fiscalYear.endDate).getUTCFullYear();
				// save so addFiscalYearCols() will have a value to use
				defaultYear = year;
			}


			// Go from start month of year to last month
			for (var i = startMonth; i <= 11; i++) {
				vm.months['month' + i].year = year;
			}

			// Go from first month to start month of year
			for (var i = 0; i <= startMonth - 1; i++) {
				vm.months['month' + i].year = year;
			}

			var monthIndexLessThanFactoryStartMonth = -1;
			var d = moment.utc(startDate);
			d.year(year);
			for (var i = 0; i <= 11; i++) {
				var column = getColumn('month' + i);
				column.display =  'FY ' + year + ': ' + d.format('MMM').toUpperCase();
				if (((d.month() + 1) < factoryDate.month && d.year() == factoryDate.year) || d.year() < factoryDate.year) {
					monthIndexLessThanFactoryStartMonth = i;
				}
				d.add(1, 'month');
			}
			vm.monthIndexLessThanFactoryStartMonth = monthIndexLessThanFactoryStartMonth;
		}

		function saveGridData() {
			var cellsUpdated = updateTargetsService.getUpdatedCells(vm.initialData, metricConfigByNdx, metricNoOfWeeks, vm.months, false);
			if (cellsUpdated.length > 0) {
				updateTargetsService.saveData(cellsUpdated, leanFilterService.getFactoryList()).then(function (isSuccess) {
					if (isSuccess) {
						$scope.$broadcast('reloadTable');
					}
				});
			} else {
				$rootScope.$emit('toast', {
					'message': 'No targets were updated',
					'success': false
				});
			}
		}

		function copyMetricTargets(metricName, metricNdx, periodType, isRatioTarget) {
			updateTargetsService.copyMetricTargets($scope, metricName, metricNdx, periodType, isRatioTarget, metricConfigByNdx, defaultYear, false);
		}

		function showLimitedMetricsMessage(response) {
			if (response.actualMetricsCount > response.currentMetricsCount) {
				$timeout(function () {
					$scope.clearToast();
					var message = 'Showing {0} out of {1} metrics. Please refine your filters.';
					$rootScope.$emit('toast', {
						message: String.format(message, response.currentMetricsCount, response.actualMetricsCount),
						success: false
					});
				}, 0);
			}
		}



		function getFiscalYear() {
			var firstFiscalMonth = globalConfig.customer.startingMonthOfFiscalYear + 1;
			var calendarMonth = new Date().getMonth() + 1;
			var calendarYear = new Date().getFullYear();
			var fiscalMonth = calendarMonth - firstFiscalMonth + 1;
			if (fiscalMonth < 1) {
				fiscalMonth += 12;
			}

			var fiscalYear = calendarYear;
			if (calendarMonth < firstFiscalMonth) {
				fiscalYear -= 1;
			}
			return fiscalYear;
		}
	}
})();
